import {
    CLEAR_NUCLEAR,
    GET_NUCLEAR_DOCUMENT,
    NUCLEAR_DOC_LOADING,
    RESET_NUCLEAR_MODAL,
} from './nuclearList.type'
import axios from 'axios'
import { toggleDeactivateModal, toggleSessionModal } from '../../modals/toggleModal.actions'

export const getNuclearDocument = (payload, token) => async (dispatch) => {
    dispatch({
        type: NUCLEAR_DOC_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/nuclear/list-documents`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_NUCLEAR_DOCUMENT,
                    payload: response.data.output,
                })
                dispatch({
                    type: NUCLEAR_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: NUCLEAR_DOC_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: NUCLEAR_DOC_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const resetNuclearDocument = () => (dispatch) => {
    dispatch({
        type: RESET_NUCLEAR_MODAL,
    })
}
export const clearNuclear = () => (dispatch) => {
    dispatch({
        type: CLEAR_NUCLEAR,
    })
}
